__turbopack_context__.v({
  "className": "inter_a3357c85-module__BUxS6W__className",
});
